import { render } from "./our-partner-handbag-hero.vue?vue&type=template&id=d84d1d80&scoped=true"
import script from "./our-partner-handbag-hero.vue?vue&type=script&lang=js"
export * from "./our-partner-handbag-hero.vue?vue&type=script&lang=js"

import "./our-partner-handbag-hero.vue?vue&type=style&index=0&id=d84d1d80&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d84d1d80"]])

export default __exports__